// This method returns a component's scoped style attribute name: `data-v-xxxxxxx`
// The `_scopeId` options property is added by vue-loader when using scoped styles
// and will be `undefined` if no scoped styles are in use
var getScopeId = function getScopeId(vm) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return vm ? vm.$options._scopeId || defaultValue : defaultValue;
};

export default getScopeId;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/get-scope-id.js
// module id = 103
// module chunks = 44